// This function allow to reference all chunks
__webpack_require__.cssAssetFileName = function(chunkId) {
	// return url for filenames based on template
	return "corn-catering-oo-web-" + chunkId + "." + "de1e47076be0c1d6471e" + ".css";
};